<template>
<b-row>
   <b-col cols="12" xl="12"> 
      <b-card>
        <b-form @submit.prevent="inventoryAdd">
          <b-row>
            <b-col>
                <b-form-group label="*Receipt Date:" label-for="receiptDate">
                  <date-picker :class="{ 'is-invalid' : $v.form.vehreceiptdate.$error }" v-model="$v.form.vehreceiptdate.$model" :config="options" :wrap="false" placeholder="Select Receipt Date"></date-picker>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label="Vin Number:" label-for="vinNumber">
                    <b-form-input maxlength="40" :class="{ 'is-invalid' : $v.form.vehvin.$error }" id="vehVinNumber" v-model="$v.form.vehvin.$model" type="text" class="form-control" placeholder="Enter Vehicle Vin Number"   aria-describedby="vehVinNumber" />
                    <b-form-invalid-feedback id="vehVinNumber">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="Vehicle Receipt Sequence:" label-for="vehReceiptSeq">
                    <b-form-input maxlength="40"  :class="{ 'is-invalid' : $v.form.vehrcptseq.$error }" id="vehRcptSeq" v-model="$v.form.vehrcptseq.$model" type="text" class="form-control" placeholder="Enter Vehicle Receipt Sequence"  aria-describedby="vehRcptSeq" />
                    <b-form-invalid-feedback id="vehReceiptSeq" v-if="!$v.form.vehrcptseq.numeric">
                      Numerice Value Only
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback id="vehReceiptSeq" v-if="!$v.form.vehrcptseq.minValue">
                      Value Greater and Equal to Zero
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col>
                <b-form-group label="Vehicle Item Number:" label-for="vehitemno">
                    <b-form-input maxlength="8" id="vehitemno" v-model="form.vehitemno" type="text" class="form-control" placeholder="Enter Vehicle Item Number"   aria-describedby="vehitemno" />
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="Vehicle MFR Date:" label-for="vehmfrdateField">
                    <b-form-input id="vehmfrdateField" v-model="form.vehmfrdate" type="date" class="form-control" placeholder="Enter Organization Billing Country"  aria-describedby="vehmfrdateField" />
                </b-form-group>    
            </b-col>
            <b-col>
                <b-form-group label="Vehicle Year:" label-for="vehYearField">
                    <b-form-input id="vehYearField" v-model="form.vehyear" type="text" class="form-control" placeholder="Enter Vehicle Year"   aria-describedby="vehYearField" />
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="Mfr Name / Brand:" label-for="vehmfrField">
                    <b-form-input id="vehmfrField" v-model="form.vehmfr" type="text" class="form-control" placeholder="Enter Mfr Name / Brand"  aria-describedby="vehmfrField" />
                </b-form-group>    
            </b-col>
            <b-col>
                <b-form-group label="Mfr Model Name:" label-for="vehmodelField">
                    <b-form-input id="vehmodelField" v-model="form.vehmodel" type="text" class="form-control" placeholder="Enter Mfr Model Name"   aria-describedby="vehmodelField" />
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="Mfr Item Number:" label-for="vehmfritemnoField">
                    <b-form-input id="vehmfritemnoField" v-model="form.vehmfritemno" type="text" class="form-control" placeholder="Enter Mfr Item Number"  aria-describedby="vehmfritemnoField" />
                </b-form-group>    
            </b-col>
            <b-col>
              <b-form-group label="Vehicle Attributes:" label-for="vehattributesField">
                  <b-form-input id="vehattributesField" v-model="form.vehattributes" type="text" class="form-control" placeholder="Enter Mfr Model Name"   aria-describedby="vehattributesField" />
                  <b-form-invalid-feedback id="vehattributesField">
                     This is a required field
                  </b-form-invalid-feedback>
              </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="Vehicle Condition:" label-for="vehconditionField">
                  <b-form-select v-model="form.vehcondition" :options="conditionItems"  id="vehconditionField"  aria-describedby="vehconditionField" />
                </b-form-group>  
            </b-col>
            <b-col>
              <b-form-group label="Vehicle Status:" label-for="vehstatusField">
                <b-form-select  v-model="form.vehstatus" :options="statusItems"  id="vehstatusField"  aria-describedby="vehstatusField" />
              </b-form-group>  
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="Vehicle Type:" label-for="vehtypeField">
                  <b-form-select v-model="form.vehtype" :options="typeItems"  id="vehtypeField"  aria-describedby="vehtypeField" />
                </b-form-group>  
            </b-col>
            <b-col>
              <b-form-group label="Vehicle Sub Category:" label-for="vehcategoryField">
                <b-form-input id="vehcategoryField" v-model="form.vehcategory" type="text" class="form-control" placeholder="Enter Sub Category Name"   aria-describedby="vehcategoryField" />
              </b-form-group>      
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="*Selling Price:" label-for="vehpriceField">
                <b-form-input :class="{ 'is-invalid' : $v.form.vehprice.$error }" id="vehpriceField" v-model="$v.form.vehprice.$model" type="text" class="form-control" placeholder="Enter Vehicle Selling Price "   aria-describedby="vehpriceField" />
                <b-form-invalid-feedback id="vehpriceField" v-if="!$v.form.vehprice.decimal">
                   Numerice and Decimal Value Only
                </b-form-invalid-feedback>
                <b-form-invalid-feedback id="vehpriceField" v-if="!$v.form.vehprice.minValue">
                   Value Greater and Equal to Zero
                </b-form-invalid-feedback>
              </b-form-group>   
            </b-col>
            <b-col>
              <b-form-group label="Mfr Suggested Price :" label-for="vehmsrpField">
                <b-form-input :class="{ 'is-invalid' : $v.form.vehmsrp.$error }" id="vehmsrpField" v-model="$v.form.vehmsrp.$model" type="text" class="form-control" placeholder="Enter Mfr Suggested Price"   aria-describedby="vehmsrpField" />                
                <b-form-invalid-feedback id="vehmsrpField" v-if="!$v.form.vehmsrp.decimal">
                   Numerice and Decimal Value Only
                </b-form-invalid-feedback>
                <b-form-invalid-feedback id="vehmsrpField" v-if="!$v.form.vehmsrp.minValue">
                   Value Greater and Equal to Zero
                </b-form-invalid-feedback>
              </b-form-group>   
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Inter dealer price:" label-for="vehb2bpriceField">
                <b-form-input :class="{ 'is-invalid' : $v.form.vehb2bprice.$error }" id="vehb2bpriceField" v-model="$v.form.vehb2bprice.$model" type="text" class="form-control" placeholder="Enter Vehicle Selling Price " aria-describedby="vehb2bpriceField" />
                <b-form-invalid-feedback id="vehb2bpriceField" v-if="!$v.form.vehb2bprice.decimal">
                   Numerice and Decimal Value Only
                </b-form-invalid-feedback>
                <b-form-invalid-feedback id="vehb2bpriceField" v-if="!$v.form.vehb2bprice.minValue">
                  Value Greater and Equal to Zero
                </b-form-invalid-feedback>
              </b-form-group>   
            </b-col>
            <b-col>
              <b-form-group label="Vehicle Show On Web :" label-for="vehshowonwebField">
                <b-form-select v-model="form.vehshowonweb" :options="showWebItems"  id="vehshowonwebField"  aria-describedby="vehshowonwebField" />
              </b-form-group>   
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Vehicle Is Feature:" label-for="vehisfeaturedField">
                <b-form-select v-model="form.vehisfeatured" :options="featureItems"  id="vehisfeaturedField"  aria-describedby="vehisfeaturedField" />
              </b-form-group>   
            </b-col>
            <b-col>
              <b-form-group label="Vehicle On Special :" label-for="vehonspecialField">
                <b-form-select v-model="form.vehonspecial" :options="onSpecialItems"  id="vehonspecialField"  aria-describedby="vehonspecialField" />
              </b-form-group>   
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Vehicle On Rent:" label-for="vehrentalField">
                <b-form-select v-model="form.vehrental" :options="featureItems"  id="vehrentalField"  aria-describedby="vehrentalField" />
              </b-form-group>   
            </b-col>
            <b-col>
              <b-form-group label="Location :" label-for="vehlocationField">
                <b-form-input v-model="form.vehlocation" id="vehlocationField" type="text" class="form-control" placeholder="Enter Location (City,state)"    aria-describedby="vehlocationField" />
              </b-form-group>   
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Unit Cost:" label-for="vehunitcostField">
                <b-form-input :class="{ 'is-invalid' : $v.form.vehunitcost.$error }" v-model="$v.form.vehunitcost.$model" id="vehunitcostField" type="text" class="form-control" placeholder="Enter Vehicle Unit Cost"    aria-describedby="vehunitcostField" @change="updateTotalCost()"/>                
                <b-form-invalid-feedback id="vehunitcostField" v-if="!$v.form.vehunitcost.decimal">
                   Numerice and Decimal Value Only
                </b-form-invalid-feedback>
                <b-form-invalid-feedback id="vehunitcostField" v-if="!$v.form.vehunitcost.minValue">
                  Value Greater and Equal to Zero
                </b-form-invalid-feedback>
              </b-form-group>   
            </b-col>
            <b-col>
              <b-form-group label="Shipping Cost :" label-for="vehfreightcostField">
                <b-form-input :class="{ 'is-invalid' : $v.form.vehfreightcost.$error }" v-model="$v.form.vehfreightcost.$model" id="vehfreightcostField" type="text" class="form-control" placeholder="Enter Vehicle Shipping Cost" aria-describedby="vehfreightcostField" @change="updateTotalCost()"/>                
                <b-form-invalid-feedback id="vehfreightcostField" v-if="!$v.form.vehfreightcost.decimal">
                   Numerice and Decimal Value Only
                </b-form-invalid-feedback>
                <b-form-invalid-feedback id="vehfreightcostField" v-if="!$v.form.vehfreightcost.minValue">
                  Value Greater and Equal to Zero
                </b-form-invalid-feedback>
              </b-form-group>   
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Prep Cost:" label-for="vehprepcostField">
                <b-form-input :class="{ 'is-invalid' : $v.form.vehprepcost.$error }" v-model="$v.form.vehprepcost.$model" id="vehprepcostField" type="text" class="form-control" placeholder="Enter Vehicle Prep Cost"    aria-describedby="vehprepcostField" @change="updateTotalCost()"/>                
                <b-form-invalid-feedback id="vehprepcostField" v-if="!$v.form.vehprepcost.decimal">
                  Numerice and Decimal Value Only
                </b-form-invalid-feedback>
                <b-form-invalid-feedback id="vehprepcostField" v-if="!$v.form.vehprepcost.minValue">
                  Value Greater and Equal to Zero
                </b-form-invalid-feedback>
              </b-form-group>   
            </b-col>
            <b-col>
              <b-form-group label="Total Cost :" label-for="vehtotcostField">
                <b-form-input v-model="form.vehtotcost" disabled id="vehtotcostField" type="text" class="form-control" placeholder="Enter Vehicle Shipping Cost" aria-describedby="vehtotcostField" />
              </b-form-group>   
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
                  <b-form-group label="Minimum Selling Price:" label-for="vehminpriceField">
                    <b-form-input :class="{ 'is-invalid' : $v.form.vehminprice.$error }" v-model="$v.form.vehminprice.$model" id="vehminpriceField" type="text" class="form-control" placeholder="Enter Vehicle Minimum Selling Price" aria-describedby="vehminpriceField" />
                    <b-form-invalid-feedback id="vehminpriceField" v-if="!$v.form.vehminprice.decimal">
                       Numerice and Decimal Value Only
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback id="vehminpriceField" v-if="!$v.form.vehminprice.minValue">
                      Value Greater and Equal to Zero
                    </b-form-invalid-feedback>
                  </b-form-group>    
            </b-col>
          </b-row>
          <b-row style="margin-top:20px;">
            <b-col cols="12">
              <b-button type="button" v-b-tooltip.hover title="Cancel" variant="secondary" @click.stop="gotolist()"  class="px-4">Cancel</b-button>
              <b-button type="submit" v-b-tooltip.hover title="Save" variant="primary"  class="px-4 pull-right">Save</b-button> 
            </b-col>
          </b-row>
        </b-form>
      </b-card>
  </b-col>
</b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'  
import { validationMixin } from 'vuelidate' 
import { required, decimal, minValue, numeric } from 'vuelidate/lib/validators'
import { getResponseMessages, dateFormatFunction } from '../../_helpers'
// Import this component
import datePicker from 'vue-bootstrap-datetimepicker';

// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
export default {
  name: 'Inventory_Add',
  components: {
    datePicker
  },
  data() {
    return {
      options: {
        format: 'DD/MM/YYYY',
        useCurrent: true,
        date: new Date()
      },
      fileOnjk:'',
      conditionItems:[
        {
          text: 'Please select Vehicles Condition',
          value: '',
        },
        {
          text: 'New',
          value: 'New',
        },
        {
          text: 'Used',
          value: 'Used',
        }
      ],
      statusItems:[
        {
          text: 'Please select Status',
          value: '',
        },
        {
          text: 'Quote',
          value: 'Quote',
        },
        {
          text: 'Available',
          value: 'Available',
        },
        {
          text: 'Sold',
          value: 'Sold',
        }
      ],
      typeItems:[
        {
          text: 'Please select Type',
          value: '',
        },
        {
          text: 'Trailer',
          value: 'Trailer',
        },
        {
          text: 'HorseTrailer',
          value: 'HorseTrailer',
        },
        {
          text: 'RV',
          value: 'RV',
        },
        {
          text: 'Vehicle',
          value: 'Vehicle',
        },
        {
          text: 'Watercraft',
          value: 'Watercraft',
        },
        {
          text: 'Equipment',
          value: 'Equipment',
        }
      ],
      showWebItems:[
        {
          text: 'Please select',
          value: '',
        },
        {
          text: 'Yes',
          value: '1',
        },
        {
          text: 'No',
          value: '0',
        }
      ],
      featureItems:[
        {
          text: 'Please select Is Feature',
          value: ''
        },
        {
          text: 'Yes',
          value: '1',
        },
        {
          text: 'No',
          value: '0',
        }
      ],
      onSpecialItems:[
        {
          text: 'Please select a Special',
          value: ''
        },
        {
          text: 'Yes',
          value: '1',
        },
        {
          text: 'No',
          value: '0',
        }
      ],
      rentallItems:[
        {
          text: 'Please select Rental',
          value: ''
        },
        {
          text: 'Yes',
          value: '1',
        },
        {
          text: 'No',
          value: '0',
        }
      ],
      previewSImage:'',
      form: {
        vehreceiptdate:dateFormatFunction(new Date(),'DD/MM/YYYY'),
        vehvin:'',
        vehrcptseq:1,
        vehitemno:'',
        vehmfrdate:'',
        vehyear:'',
        vehmfr:'',
        vehmodel:'',
        vehmfritemno:'',
        vehattributes:'',
        vehcondition:'New',
        vehstatus:'Quote',
        vehtype:'Trailer',
        vehcategory:'',
        vehprice:0,
        vehmsrp:0,
        vehb2bprice:0,
        vehshowonweb:'1',
        vehisfeatured:'1',
        vehonspecial:'1',
        vehrental:'1',
        vehlocation:'',
        vehunitcost:0,
        vehfreightcost:0,
        vehprepcost:0,
        vehtotcost:0,
        vehminprice:0,
        vehimages:''
      },
      orgItems:[{
        text: 'Please select a organization',
        value: '',
      }]
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    form: {
      vehreceiptdate: {
        required
      },
      vehvin: {
        required
      },
      vehrcptseq: {
        numeric,
        minValue:minValue(0)
      },
      vehprice: {
        decimal,
        minValue:minValue(0)
      },
      vehmsrp: {
        decimal,
        minValue:minValue(0)
      },
      vehb2bprice: {
        decimal
      },
      vehshowonweb: {
        required
      },
      vehisfeatured: {
        required
      },
      vehonspecial: {
        required
      },
      vehrental: {
        required
      },
      vehunitcost: {
        decimal,
        minValue:minValue(0)
      },
      vehfreightcost: {
        decimal,
        minValue:minValue(0)
      },
      vehprepcost: {
        decimal,
        minValue:minValue(0)
      },
      vehminprice: {
        decimal,
        minValue:minValue(0)
      }
    }  
  },
  created(){
    this.loadOrgData();
    if(this.$route.params.id != undefined){
      this.getInvtById(this.$route.params.id)
    }
  },  
  methods: {
     ...mapActions('Inventory', ['getById','uploadData']),
    updateTotalCost(){
      this.form.vehunitcost = parseFloat(this.form.vehunitcost);
      this.form.vehfreightcost = parseFloat(this.form.vehfreightcost);
      this.form.vehprepcost = parseFloat(this.form.vehprepcost);
      this.form.vehtotcost = this.form.vehunitcost + this.form.vehfreightcost + this.form.vehprepcost;
    },
    inventoryAdd() {
      this.$v.form.$touch();
      if(this.$v.form.$error) return
      const formData = new FormData();
      const formObj = Object.assign({}, this.form)  
      // formData.append('image', this.fileOnjk) 
      Object.keys(formObj).map(function(key){ 
        formData.append(key, formObj[key])  
      })
      this.$store.dispatch('uploadData',{url:'Vehicles/saveVehicle',data: formData }).then((res) => {
        this.$toastr('success', getResponseMessages(res.data.messages), 'Success')
        this.$router.push('/inventory')
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    gotolist(){
      this.$router.push('/inventory/')
    },
    loadOrgData(){
      this.$store.dispatch('getById', {url:'user/loadUserData',data :{}}).then((res) => {
        res.org.forEach((version) => {
          this.orgItems.push(version);
        });
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    getInvtById(id){
      this.$store.dispatch('getById', {url:'vehicles/getVehicleDetailsById',data : { 'vehIndex':id }}).then((res) => {
        this.form = Object.assign({}, res.details)
        this.options.date = dateFormatFunction(res.details.vehreceiptdate,'DD/MM/YYYY');
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    }
  },
}
</script>
<style type="text/css">
  .vc-chrome {
  position: absolute;
  top: 35px;
  right: 0;
  z-index: 9;
}
.current-color {
  width: 40px;
  height: 35px;
  cursor: pointer;
}
</style>
